import React, { useContext, useEffect, useState, useRef } from 'react'
import 'moment-timezone'
import { useScreenshot } from 'use-react-screenshot'
import { Container } from 'react-bootstrap'
import { SocketContext } from '../components/ContextProvider'

function Capturer() {
  const { socket } = useContext(SocketContext)
  const [url, seturl] = useState({
    url: '',
    width: 540,
    height: 690,
  })
  useEffect(() => {
    if (socket !== null) {
      socket.on('url', (message) => {
        console.log(message)
        seturl(message)
        // if (message) setChats(message)
      })
      // can receive streaming response too
      // socket.on('stream', (message) => {
      //   if (message) setGptMessage((prevState) => `${prevState}${message}`)
      // })
    }
  }, [socket])

  //   const sendMessage = (text) => {
  //     setgenerating(true)
  //     socket.emit('gpt', text)
  //   }
  const ref = useRef(null)
  const [printing, setprinting] = useState(false)
  const [image, takeScreenshot] = useScreenshot()
  const print = () => {
    const link = document.createElement('a')
    link.setAttribute('href', image)
    link.setAttribute('download', 'image.png')
    document.body.appendChild(link)

    link.click()
    link.remove()
    setprinting(false)
  }
  useEffect(() => {
    if (!image) return
    print()
  }, [image])
  useEffect(() => {
    if (printing) {
      if (!image) takeScreenshot(ref.current)
      else print()
    }
  }, [printing])

  return (
    <Container
      className="h-100 w-100"
      // onClick={() => setEditing('')}
    >
      <button type="button" onClick={() => setprinting(true)} />
      {url && (
        <iframe
          ref={ref}
          title="url"
          height="1500px"
          width="1000px"
          src={url.url}
        />
      )}
    </Container>
  )
}

export default Capturer
